import FFPaidTransfersAlphaBuyerSurvey from '@wetransfer/transfer/constant/flags/paid-transfers-alpha-buyer-survey';
import concordeCookie from '@wetransfer/transfer/modules/concorde-cookie';

import { DID_SEE_PANEL_COOKIE_KEY } from './constants';

export const didUserSeePaidTransfersAlphaBuyerSurvey = (): boolean =>
  Boolean(concordeCookie.get(DID_SEE_PANEL_COOKIE_KEY));

export const shouldShowPaidTransfersAlphaBuyerSurvey = (
  isPaidTransfer?: boolean
): boolean =>
  FFPaidTransfersAlphaBuyerSurvey.isOn() &&
  Boolean(isPaidTransfer) &&
  !didUserSeePaidTransfersAlphaBuyerSurvey();
